var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table is-narrow is-fullwidth is-marginless" }, [
      _c(
        "tbody",
        _vm._l(_vm.permisos, function (permisos, nivel) {
          return _c("tr", { key: `permiso-nivel-info-${nivel}` }, [
            _c("th", { attrs: { width: "70" } }, [
              _vm._v("Nivel " + _vm._s(nivel)),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                { staticClass: "field is-grouped is-grouped-multiline" },
                _vm._l(permisos, function (permiso, i) {
                  return _c(
                    "div",
                    {
                      key: `permiso-${nivel}-info-${i}`,
                      staticClass: "control",
                    },
                    [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c(
                          "span",
                          {
                            staticClass: "tag",
                            class: _vm.getLevelColor(nivel),
                          },
                          [_c("i", { class: _vm.getLevelIcon(nivel) })]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "tag is-light",
                          class: _vm.getLevelColor(nivel),
                          domProps: { innerHTML: _vm._s(permiso) },
                        }),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "help" }, [
      _vm._v("(*) Requiere rol de usuario de aspectos"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }